<template>
  <BaseModule
    v-bind="$props"
    class="container custom-html"
    data-module="custom-html"
  >
    <header
      v-if="title || subtitle"
      class="base-title-fontsize"
    >
      <component
        :is="titleTag"
        v-if="title"
        class="tit tit-g"
      >
        {{ title }}
      </component>
      <h3
        v-if="subtitle"
        class="sub"
      >
        {{ subtitle }}
      </h3>
    </header>
    <div
      v-if="running"
      ref="htmlContent"
      class="html-content"
    ></div>
    <Warning
      v-else
      text="Para visualizar seu código acesse o preview"
    />
  </BaseModule>
</template>

<script>
import debounce from 'lodash/debounce';

import base from '@/mixins/base';
import injectHTML from '@/helpers/injectHTML';
import Warning from '@/components/Warning.vue';
import BaseModule from './generic/BaseModule.vue';

export default {
  name: 'CustomHTML',
  components: {
    Warning,
    BaseModule,
  },
  mixins: [base],
  inheritAttrs: false,
  props: {
    ...BaseModule.props,
    html: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      running: false,
    };
  },
  computed: {
    onCanvas() {
      return this.$route.name === 'editor';
    },
  },
  watch: {
    html: {
      // eslint-disable-next-line func-names
      handler: debounce(function (newValue) {
        this.inject(newValue);
      }, 1500),
    },
  },
  mounted() {
    this.inject(this.html);
  },
  methods: {
    isIframeOnly(html) {
      const iframeRegex = /^<iframe[^<]+<\/iframe>$/;

      return iframeRegex.test(html);
    },
    inject(html) {
      if (html.trim() && (!this.onCanvas || this.isIframeOnly(html))) {
        this.running = true;
        this.$nextTick(() => {
          injectHTML(this.$refs.htmlContent, html);
        });
      } else {
        this.running = false;
      }
    },
  },
  metadata: {
    extends: BaseModule.metadata,
    tabs: [
      {
        name: 'content',
        groups: [
          {
            name: 'code',
            label: 'Código',
            fields: [
              {
                name: 'html',
                type: 'HTMLEditor',
                label: 'Código HTML',
                helpText:
                  'Neste campo é possível inserir qualquer código HTML.<br>Além das tags básicas, é possível inserir Javascript utilizando a tag <b>&lt;script&gt</b> e CSS de forma inline ou dentro de uma tag <b>&lt;style&gt</b>.',
              },
            ],
          },
        ],
      },
      {
        name: 'appearance',
        groups: [
          {
            name: 'colors',
            toRemove: ['textColor', 'buttonColor', 'buttonTextColor'],
          },
          {
            name: 'fonts',
            toRemove: ['contentSizeDesk', 'contentSizeMobile'],
          },
        ],
      },
    ],
  },
};
</script>

<style scoped lang="scss">
.custom-html {
  padding: 0;
  padding-top: var(--padding-top);
  padding-bottom: var(--padding-bottom);

  header {
    text-align: center;
  }

  @include media-breakpoint-down(sm) {
    padding-top: var(--padding-top-mobile);
    padding-bottom: var(--padding-bottom-mobile);
  }
}
</style>
